<template>
  <div class="container pay">
    <div class="pay-item">
      <div class="seller" @click="addressshow = true">
        <van-cell is-link>
          <template slot="title">
            <i class="iconfont iconziyuan"></i>
            <div class="seller-info">
              <span class="name">{{username}}</span>
              <span class="phone">{{phone}}</span>
              <p class="address">{{province}}{{city}}{{area}}{{detail}}</p>
            </div>
            <p class="NoDefault" v-show="addressID.length === 0">请选择收货地址</p>
          </template>
        </van-cell>
      </div>
      <div class="seller goods_pay_item">
        <p class="pay_title">已选购商品</p>
        <div class="goods-list">
          <div class="goods-img" :style="{backgroundImage: 'url(' + product.logo + ')'}">
            <van-tag type="primary" v-if="product.isrecommend"><i class="iconfont iconshujituijian"></i>推荐</van-tag>
          </div>
          <div class="goods-info">
            <div class="goods-title van-multi-ellipsis--l2">{{product.productname}}</div>
            <div class="goods-price">
              <div class="price_num">
                <span class="price">¥{{product.price}}</span>
                <span class="num">已选，{{num}}本</span>
              </div>
              <van-stepper class="goods_num_step" v-model="num" :max="product.banlancenum" integer @change="pricechange"/>
            </div>
          </div>
        </div>
      </div>
      <div class="seller pay_remark">
        <van-field v-model="remark" type="textarea" rows="1" autosize label="订单备注" placeholder="填写备注" />
      </div>
      <div class="seller amountList">
        <div class="amount_list">
          <div class="amount_label">商品总额</div>
          <div class="amount_val">￥{{productAmount}}</div> 
        </div>
        <div class="amount_list">
          <div class="amount_label">快递运费</div>
          <div class="amount_val expressfee">+￥{{product.expressfee}}</div> 
        </div>
      </div>
      <div class="seller pay_type">
        <div class="title">支付方式</div>
        <van-radio-group v-model="paytype">
          <van-cell-group>
            <van-cell clickable @click="paytype = '0'" v-if="iswx">
              <div slot="title" class="pay_type_item">
                <i class="iconfont iconweixinzf_"></i>微信
              </div>
              <van-radio slot="right-icon" name="0" />
            </van-cell>
            <van-cell clickable @click="paytype = '1'" v-if="!iswx">
              <div slot="title" class="pay_type_item">
                <i class="iconfont iconzhifubzf_"></i>支付宝
              </div>
              <van-radio slot="right-icon" name="1" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </div>
    <van-popup class="chooseaddress" v-model="addressshow" position="right" :overlay="true">
      <van-nav-bar
        left-text="常用地址"
        left-arrow
        @click-left="addressshow = false"
      />
      <van-radio-group v-model="addressID">
        <van-cell-group>
        <div class="seller">
          <van-cell v-for="address in addressData" :key="address.id" @click="changeaddress(address)">
            <template slot="title">
              <i class="iconfont iconziyuan"></i>
              <div class="seller-info">
                <span class="name">{{ address.linkman }}</span>
                <span class="phone">{{ address.linkphone }}</span>
                <p class="address">{{ address.province }}{{ address.city }}{{ address.area }}{{ address.address }}</p>
              </div>
            </template>
            <van-radio checked-color="#DB2D2D" :name="address.id" />
          </van-cell>
        </div>
        </van-cell-group>
      </van-radio-group>
      <div class="noaddress" v-show="addressData.length < 1">
        <p>您还没添加收货地址</p>
        <!-- <div @click="$router.push({path: '/address'})">添加我的收货地址</div> -->
      </div>
      <div class="addaddress">
        <van-button @click.native="$router.push({path: '/address/form', query: {URL: '/order/pay'}})">添加新地址</van-button>
      </div>
    </van-popup>
    <van-submit-bar
      :price="amount*100"
      button-text="提交订单"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  import throttle from 'lodash/throttle'
  const u = navigator.userAgent
  let priceLoad
  export default {
    name: 'pay',
    data () {
      return {
        addressshow: false,
        addressID: '',
        username: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        detail: '',
        addressData: [],
        product: {},
        num: 1,
        remark: '',
        paytype: '',
        iswx: false
      }
    },
    computed: {
      amount () {
        if (priceLoad) {
          priceLoad.clear()
        }
        return this.num * this.product.price + this.product.expressfee
      },
      productAmount () {
        if (priceLoad) {
          priceLoad.clear()
        }
        return this.num * this.product.price
      }
      // profile () {
      //   return this.$store.state.userinfo
      // }
    },
    created () {
      if (u.indexOf('MicroMessenger') > -1) {
        this.iswx = true
        this.paytype = '0'
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let url=''
        if (isAndroid) {
          url=location.href
        }
        if (isIOS) {
          url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
        }
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: url
        }).then(response => {
          let data = response.data
          wx.config({
            beta: true,
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        })
      } else {
        this.iswx = false
        this.paytype = '1'
      }
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      let id = this.$store.state.product.id
      this.num = this.$store.state.product.num
      this.$fetch.get(API.PRODUCTDETAIL, {
        id: id
      }).then(response => {
        load.clear()
        if (response.status !== 200) {
          var msg = response.message? response.message : '商品详情获取失败，请刷新！'
          this.$toast.fail(msg)
          return
        }
        this.product = response.data
      }).catch(error => {
        console.log(error)
        load.clear()
      })
    },
    mounted () {
      this.$fetch.get(API.MEMBERADDRESS).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var msg = response.message? response.message : '收货地址获取失败!'
          this.$toast.fail(msg)
          return
        }
        this.addressData = response.data
        for(var i = 0; i < response.data.length; i++) {
          if (response.data[i].isdefault === 1) {
            this.username = response.data[i].linkman
            this.phone = response.data[i].linkphone
            this.province = response.data[i].province
            this.city = response.data[i].city
            this.area = response.data[i].area
            this.detail = response.data[i].address
            this.addressID = response.data[i].id
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    methods: {
      changeaddress (address) {
        this.addressID = address.id
        this.username = address.linkman
        this.phone = address.linkphone
        this.province = address.province
        this.city = address.city
        this.area = address.area
        this.detail = address.address
        this.addressshow = false
      },
      onSubmit: throttle(function() {
        if(!this.addressID) {
          this.$toast.fail('请选择收货地址')
          return
        }
        if (!this.product.id) {
          this.$toast.fail('订单不能为空，请重新添加商品！')
          return
        }
        const payLoad= this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        var productJson = [{
          productid: this.product.id,
          num: this.num
        }]
        this.$fetch.post(API.CREATEORDER, {
          ordertype: this.product.type,
          addressid: this.addressID,
          productjson: JSON.stringify(productJson),
          remark: this.remark,
          amount: this.amount,
          payamount: this.amount,
          paytype: this.paytype
        }).then(response => {
          payLoad.clear()
          // console.log(response)
          if (response.status !== 200) {
            var msg = response.message? response.message : '订单创建失败，请重新提交！'
            this.$toast.fail(msg)
            return
          }
          if (this.paytype === '1') {
            this.aliorderpay(response.data.orderno)
          } else {
            this.orderPay(response.data.orderno, response.data.id)
          }
        }).catch(error => {
          payLoad.clear()
          var msg = error.message? error.message : '订单创建失败，请重新提交！'
          this.$toast.fail(msg)
          console.log(error)
        })
      }, 3000, { 'trailing': false }),
      orderPay (orderno, id) {
        if (u.indexOf('MicroMessenger') > -1) {
          this.$fetch.post(API.WECHATPAY, {
            orderno: orderno
          }).then(response => {
            // console.log(response.data)
            let data = response.data
            let options = {
              timestamp: data.timeStamp, // 时间戳，自1970年以来的秒数
              nonceStr: data.nonceStr, // 随机串
              package: data.package,
              signType: data.signType, // 微信签名方式:
              paySign: data.paySign, // 微信签名
              success: (res) => {
                // console.log(res)
                this.$router.replace({path:'/pay/result', query: {id: id}})
              },
              cancel: (res) => {
                // console.log(res)
                this.$toast.fail('已取消订单支付')
              },
              fail: (res) => {
                this.$router.replace({path:'/pay/result', query: {id: id}})
              }
            }
            // 唤起微信支付
            wx.chooseWXPay(options)
          })
        } else {
          this.$toast.fail('请在微信客户端内支付')
        }
      },
      aliorderpay (orderno) {
        this.$fetch.post(API.ALIPAY, {
          orderno: orderno
        }).then(response => {
          // console.log(response)
          if (response.status !== 200) {
            var msg = response.message? response.message : '支付宝唤起支付失败，请刷新重试！'
            this.$toast.fail(msg)
            return
          }
          window.location.href = response.data.payurl
          // this.alipayWap = response
        }).catch(err => {
          console.log(err)
        })
      },
      pricechange () {
        priceLoad= this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
      }
    }
  }
</script>

<style lang="stylus">
</style>